import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import * as actions from 'Modules/SearchModule/actions'
import * as selectors from './selectors'

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapStateToProps = (state, ownProps) => ({
    advisorOptions: selectors.advisorOptions(state),
    extendedFilters: selectors.extendedFilters(state),
    reservationEventOptions: selectors.reservationEventOptions(state),
    reservationUserOptions: selectors.reservationUserOptions(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    applyExtendedFilters: filters => dispatch(actions.filtersExtendedApply(filters)),
    resetExtendedFilters: () => dispatch(actions.filtersExtendedReset()),
  })

  Enhancer.displayName = 'ExtendedSearchModalEnhancer'

  Enhancer.propTypes = {
    advisorOptions: PropTypes.array.isRequired,
    applyFilters: PropTypes.func.isRequired,
    applyExtendedFilters: PropTypes.func.isRequired,
    extendedFilters: PropTypes.object.isRequired,
    reservationEventOptions: PropTypes.array.isRequired,
    reservationUserOptions: PropTypes.array.isRequired,
    resetExtendedFilters: PropTypes.func.isRequired,
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Enhancer)
}
